import Head from "next/head";

import { SignUpPage } from "@fwa/src/components/SignUpPage";

import sharedStyles from "@fwa/src/components/styles.module.css";

const Account = () => (
  <>
    <Head>
      <title>Create your Giving Page</title>
      <meta name="robots" content="noindex" />
    </Head>

    <div className={sharedStyles["content-max-width"]}>
      <SignUpPage />
    </div>
  </>
);

export default Account;
